import React from 'react'

/**
 * A simple loading spinner component. This component is automatically centered in a flex container.
 * @param color - The color of the spinner. Default is 'text-logo'.
 * @param className - Additional classes to apply to the spinner.
 * @param small - If true, the spinner will be smaller.
 */
export const Loader: React.FC<{ color?: string; className?: string; small?: boolean }> = ({
  color = 'text-logo',
  className = '',
  small,
}) => {
  return (
    <div className={`flex h-full w-full flex-grow items-center justify-center ${color} ${className}`}>
      <div
        className={`${small ? 'h-6 w-6' : 'h-8 w-8'} animate-spin rounded-full border-4 border-current border-t-transparent`}
      />
    </div>
  )
}

/**
 * A loading spinner component that is positioned absolutely in the center of the relative parent, on top of other content.Ï
 */
export const FloatingLoader: React.FC<{ color?: string; background?: string; className?: string }> = ({
  color = 'text-logo',
  background = '',
  className = '',
}) => (
  <div
    className={`pointer-events-none absolute inset-0 z-50 flex items-center justify-center ${background} ${className}`}
  >
    <Loader color={color} />
  </div>
)
